import { VaporEmptyState, VaporEmptyStateProps } from "../VaporEmptyState";
export const EmptyState = VaporEmptyState;
export interface EmptyStateProps extends VaporEmptyStateProps {}
